import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=613539ca&scoped=true&"
import script from "./InfoItem.vue?vue&type=script&lang=js&"
export * from "./InfoItem.vue?vue&type=script&lang=js&"
import style0 from "./InfoItem.vue?vue&type=style&index=0&id=613539ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613539ca",
  null
  
)

export default component.exports